/** Admin: global secret/config field schema. */
import { apiDelete, apiGet, apiPost } from '../client.js';
import type { CreateSecretFieldBody, SecretField } from '../types.js';

export function listSecretFields(): Promise<SecretField[]> {
  return apiGet<SecretField[]>('/api/v1/admin/secret-fields');
}

export function createSecretField(body: CreateSecretFieldBody): Promise<SecretField> {
  return apiPost<SecretField>('/api/v1/admin/secret-fields', body);
}

export function deleteSecretField(id: string): Promise<void> {
  return apiDelete<void>(`/api/v1/admin/secret-fields/${id}`);
}
